/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ChargeType = {
    NotSpecified: 'NotSpecified',
    Subscription: 'Subscription',
    Fee: 'Fee',
    Tariff: 'Tariff',
} as const;
export type ChargeType = typeof ChargeType[keyof typeof ChargeType];

